module.exports = __webpack_public_path__ + "static/img/起重机.4fad2fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type1-1-model/起重机.png
// module id = 4bxb
// module chunks = 0